<template>
  <div id="app">
    <div class="background" :class="{ 'half-background': $route.path.includes('dashboard') }"/>
    <div class="relative height-100">
      <transition name="faded" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="less">
body, html, #app {
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.faded-enter-active, .faded-leave-active {
  transition: opacity .3s ease, transform .3s ease;
}
.faded-enter, .faded-leave-to {
  opacity: 0;
}
.faded-enter {
  transform: translateY(50px);
}
 .faded-leave-to {
  transform: translateY(-50px);
}

.height-100 {
    height: 100% !important;
}

.background {
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  transform-origin: top center;
  background-color: @secondary-color;
  transform-origin: top center;
  transition: .3s ease transform;
  transition-delay: .2s;
  &.half-background {
    transform: scaleY(0.4);
  }
}

.logo {
  max-width: 180px;
}

h1 {
  color: #fff !important;
}

.border-bottom {
  border-color: #D8D8D8;
}

.ant-card, .ant-select-dropdown {
  border: none !important;
  border-radius: @border-radius-base !important;
  box-shadow: 0 10px 40px 0 rgba(76,88,128,0.20), 0 1px 2px 0 rgba(76,88,128,0.10) !important;
}
.ant-select-dropdown {
   -webkit-transform:translateZ(1px);
    -moz-transform:translateZ(1px);
    -o-transform:translateZ(1px);
    transform:translateZ(1px);
}
.ant-card-body {
  padding: 20px !important;
  .ant-divider {
    margin-left: -20px;
    margin-right: -20px;
    width: calc(100% + 40px);
  }
}
.ant-btn {
  text-align: left !important;
  text-shadow: none !important;
  &.ant-btn {
    &-primary {
      min-width: 158px;
      box-shadow: 0 10px 40px 0 rgba(236,23,91,0.34), 0 1px 2px 0 rgba(57,13,27,0.10);
      padding: 14px 18px !important;
      font-size: 14px !important;
      height: auto !important;
    }
  }
  .anticon { 
    float: right;
  }
}

.ant-form-item-label {
  line-height: 18px !important;
  margin-bottom: 6px;
  label {
    font-size: 12px !important;
  }
}

.hamburger-menu {
  display: none;
  color: #fff;
  font-size: 26px;
  position: absolute; 
  right:20px;
  top: 25px;
  i {
    position: absolute;
    right:0;
  }
  .opened {
    opacity: 0;
  }
  &.is-open {
    .closed {
      opacity: 0;
    }
    .opened {
      opacity: 1;
    }
  }
}

.menu-logo, .mobile-header {
  display: none;
}

@media (max-width: 768px) {
  .logo-center {
    position: fixed;
    top: 28%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0px;
  }
  .ant-layout-header {
    box-shadow: 0 10px 40px 0 rgba(76, 88, 128, 0.2), 0 1px 2px 0 rgba(76, 88, 128, 0.1) !important;
  }
  .background {
    &.half-background {
      transform: scaleY(1);
    }
  }
  .ant-layout-content {
    padding: 20px 20px 0 20px !important;
  }
  .mobile-offset {
    margin-left: -20px !important;
    margin-right: -20px !important;
  }
  .mobile-sticky {
    position: sticky !important;
    top:110px;
  }
  .hamburger-menu {
    display: block;
    z-index: 1001;
    -webkit-transform:translateZ(1px);
    -moz-transform:translateZ(1px);
    -o-transform:translateZ(1px);
    transform:translateZ(1px);
  }
  .mobile-header {
    display: inline;
    h2 {
      display: inline-block;
      margin: 0 0 0 -5px;
      color: #fff;
      i {
        opacity: 0.8;
      }
    }
  }
  .menu {
    transition: .3s ease transform;
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    height: 100vh;
    background: @secondary-color;
    z-index: 1000;
    transform: translateX(100%);
    // -webkit-transform:translate3d(100%, 0, 1px);
    // -moz-transform:translate3d(100%, 0, 1px);
    // -o-transform:translate3d(100%, 0, 1px);
    // transform:translate3d(100%, 0, 1px);
    .menu-logo {
      padding: 30px;
      max-width: 200px;
      display: inline-block;
    }
    .ant-menu-submenu {
      display: none  !important;
    }
    li {
      width: 100%;
      display: block !important;
      padding: 20px !important;
      border-bottom: 1px rgba(255,255,255,0.2) solid !important;
      .router-link-active {
        border: none !important;
      }
    }
    ul {
      float: left;
      width:100%;
    }
    &.is-open {
          transform: translateX(0%);

      // -webkit-transform:translate3d(0%, 0, 1px);
      // -moz-transform:translate3d(0%, 0, 1px);
      // -o-transform:translate3d(0%, 0, 1px);
      // transform:translate3d(0%, 0, 1px);
    }
  }

  
  .mobile-card {
    -webkit-transform:translateZ(1px);
    -moz-transform:translateZ(1px);
    -o-transform:translateZ(1px);
    transform:translateZ(1px);
    position: relative;
    background-color: #fff;
    border-radius: 10px 10px 0 0 !important;
    height: auto !important;
    h1 {
      color: @secondary-color !important; 
      & ~ .card .ant-card-body {
        padding: 0px !important;
      }
    }
    
    & > * {
      height: auto !important;
    }
    &:before {
      content: '';
      position: absolute;
      top:-50px;
      left:0;
      right:0;
      height: 50px;
      display: block !important;
      background: linear-gradient( rgba( @secondary-color, 0), @secondary-color);
    }
  }
  .ant-card {
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 0px !important;
    border-bottom: 1px solid rgba(0,0,0,0.1) !important;
    margin-bottom: -16px !important;
    padding:16px 0 !important;
  }
  .mobile-snap-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .ant-form-item, button {
      width: 100%;
    }
  }
  .dashboard {
    height: auto !important;
    .logo {
      display: none;
    }
  }
}
@media (max-width: 320px) {
    .logo-center {
      top: 18%;
    }
}
</style>
